import { render, staticRenderFns } from "./mouthModal.vue?vue&type=template&id=1c1f8996&scoped=true"
import script from "./mouthModal.vue?vue&type=script&lang=js"
export * from "./mouthModal.vue?vue&type=script&lang=js"
import style0 from "./mouthModal.vue?vue&type=style&index=0&id=1c1f8996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1f8996",
  null
  
)

export default component.exports